import React from 'react'

export default function BurgerIcon() {
    return (
        <div>
            <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.5417 34.1877C26.5417 33.3425 25.8557 32.6565 25.0104 32.6565H5.61459C4.76934 32.6565 4.08334 33.3425 4.08334 34.1877C4.08334 35.033 4.76934 35.719 5.61459 35.719H25.0104C25.8557 35.719 26.5417 35.033 26.5417 34.1877ZM44.9167 23.9794C44.9167 23.1341 44.2307 22.4481 43.3854 22.4481H5.61459C4.76934 22.4481 4.08334 23.1341 4.08334 23.9794C4.08334 24.8246 4.76934 25.5106 5.61459 25.5106H43.3854C44.2307 25.5106 44.9167 24.8246 44.9167 23.9794ZM36.75 13.771C36.75 12.9258 36.064 12.2398 35.2188 12.2398H5.61459C4.76934 12.2398 4.08334 12.9258 4.08334 13.771C4.08334 14.6163 4.76934 15.3023 5.61459 15.3023H35.2188C36.064 15.3023 36.75 14.6163 36.75 13.771Z" fill="black" />
            </svg>
        </div>
    )
}
